<template>
    <AuthLayout>
        <div class="flex h-screen ">
            <Toast />
            <div class="hidden lg:block lg:w-7/12">
                <img src="@/assets/left-side.jpg" alt="Welcome Image"
                    class="h-full w-full object-cover object-center " />
            </div>

            <div id="right-side-container"
                class="flex flex-col justify-center items-center w-full lg:w-5/12 logged-out-container min-h-screen">
                <div class="flex flex-col justify-center items-center w-full max-w-lg mt-5">
                    <h1 class="welcome-back mb-20">Setting up your account</h1>
                    <p class="subtitle pb-5">Please wait a few seconds while we set up your account</p>
                    <ProgressSpinner v-if="showSpinner" class="mt-8" strokeWidth="4" animationDuration=".8s"
                        style="width: 50px; height: 50px" />
                </div>
            </div>
        </div>
    </AuthLayout>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useToast } from 'primevue/usetoast';
import AuthService from '@/services/AuthService';
import AuthLayout from '@/views/AuthLayout.vue';
import { useStore } from 'vuex';
import ProgressSpinner from 'primevue/progressspinner';

const route = useRoute();
const router = useRouter();
const toast = useToast();
const store = useStore();

const showSpinner = ref(true);
onMounted(async () => {
    try {
        const token = route.query.token;

        if (!token) {
            toast.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Invalid confirmation link',
                life: 3000
            });
            return;
        }

        // Call API to confirm email
        const response = await AuthService.confirmEmail(token);

        toast.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Email confirmed successfully!You will be redirected.',
            life: 3000
        });
        localStorage.setItem('token', response.data.token);
        store.dispatch('setUser', response.data.user);
        setTimeout(() => {
            router.push({ name: 'Home' });
        }, 1000);

    } catch (error) {
        console.error('Email confirmation error:', error);

        if (error.response?.status === 400) {
            toast.add({
                severity: 'info',
                summary: 'Already Verified',
                detail: 'This email is already verified. Redirecting to login...',
                life: 5000
            });

            setTimeout(() => {
                router.push('/login');
            }, 5000);

        } else {
            toast.add({
                severity: 'error',
                summary: 'Error',
                detail: error.response?.data?.message || 'Error confirming email. Please try again.',
                life: 3000
            });
        }
    }
});
</script>

<style scoped>
.logged-out-container {
    background-image: url('@/assets/right-side-background.png');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    height: 100svh;
}

.welcome-back {
    font-family: FMBolyarSansPro-700;
    font-size: 19px;
    color: #FFFFFF;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.50);
}

.subtitle {
    color: #9B9BA3;
}
</style>